import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { useSocket } from "@/context/SocketContext";
import { Heart, X } from "lucide-react";

const FALLBACK = "https://images.unsplash.com/photo-1637059880830-59a90102de77";

export default function MatchModal() {
  const { matchUser, clearMatch } = useSocket();
  const nav = useNavigate();

  const message = () => {
    const id = matchUser.id;
    clearMatch();
    nav(`/messages/${id}`);
  };

  return (
    <AnimatePresence>
      {matchUser && (
        <motion.div
          data-testid="match-modal"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-[9998] flex items-center justify-center px-6 bg-ink/90 backdrop-blur-md"
        >
          <div className="absolute inset-0 opacity-40 bg-[radial-gradient(circle_at_50%_40%,rgba(114,47,55,0.7),transparent_60%)]" />
          <motion.div
            initial={{ scale: 0.85, y: 30 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.9, opacity: 0 }}
            transition={{ type: "spring", stiffness: 260, damping: 22 }}
            className="relative z-10 text-center max-w-sm"
          >
            <button data-testid="match-close" onClick={clearMatch} className="absolute -top-2 right-0 text-text-muted hover:text-text-main transition-colors">
              <X size={20} />
            </button>
            <p className="text-xs uppercase tracking-[0.4em] text-gold mb-6">A mutual attraction</p>
            <div className="flex justify-center mb-8">
              <motion.div
                initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 0.2, type: "spring" }}
                className="relative"
              >
                <img
                  src={matchUser.photo_url || FALLBACK}
                  alt={matchUser.display_name}
                  className={`w-32 h-32 rounded-full object-cover border-2 border-wine ${matchUser.discreet_mode ? "blur-lg" : ""}`}
                />
                <span className="absolute -bottom-3 left-1/2 -translate-x-1/2 w-11 h-11 rounded-full bg-wine flex items-center justify-center">
                  <Heart size={18} fill="currentColor" />
                </span>
              </motion.div>
            </div>
            <h2 className="font-display text-5xl font-light leading-none mb-4">
              It's <span className="italic text-gold">mutual.</span>
            </h2>
            <p className="text-text-muted mb-10">
              You and {matchUser.display_name} admire each other. The rest is up to you.
            </p>
            <div className="flex flex-col gap-3">
              <button data-testid="match-message" onClick={message} className="py-4 bg-wine hover:bg-wine-hover transition-colors rounded-full text-sm uppercase tracking-[0.2em]">
                Send a message
              </button>
              <button data-testid="match-keep" onClick={clearMatch} className="py-4 border border-white/15 hover:border-white/30 transition-colors rounded-full text-sm uppercase tracking-[0.2em] text-text-muted">
                Keep browsing
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
